__turbopack_context__.v({
  "search_pagination_direction": "SearchPaginationDirection-module-scss-module__SrupOG__search_pagination_direction",
});
